import type Immutable from 'immutable';
import { createSelector } from 'reselect';
import type { BackupState, MaintenanceState } from './reducer';

const selectSettingsDomain = (state: any) =>
  state.get('settingsSystemBackupMaintenance');

const makeSelectSystemBackup = () =>
  createSelector<any, any, Immutable.Record<BackupState>>(
    selectSettingsDomain,
    (substate) => substate.backup,
  );
const makeSelectSystemMaintenance = () =>
  createSelector<any, any, Immutable.Record<MaintenanceState>>(
    selectSettingsDomain,
    (substate) => substate.maintenance,
  );

const makeSelectIsLoaded = () =>
  createSelector<any, any, boolean>(
    selectSettingsDomain,
    (substate) => substate.isLoaded ?? false,
  );

export {
  makeSelectSystemBackup,
  makeSelectSystemMaintenance,
  makeSelectIsLoaded,
};
